export const removeBlankValueKey = (obj) =>
  Object.keys(obj).reduce((pre, k) => {
    if (obj[k]) {
      pre[k] = obj[k];
    }
    return pre;
  }, {});

export const epochToDate = (epoch, format) => {
  const date = new Date(epoch < 99999999 ? epoch * 1000 : epoch);

  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Month is 0-indexed, add 1
  const day = date.getDate().toString().padStart(2, '0');

  const formatLowerCase = format.toLowerCase();

  switch (formatLowerCase) {
    case 'dd/mm/yyyy':
      return `${day}/${month}/${year}`;
    case 'mm/dd/yyyy':
      return `${month}/${day}/${year}`;
    case 'yyyymmdd':
      return `${year}${month}${day}`;
    case 'yyyyddmm':
      return `${year}${day}${month}`;
    default:
      // Default to 'dd/MM/YYYY' if format is not recognized
      return `${day}/${month}/${year}`;
  }
}

export const dateToDDMMYYY = (date) => {
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};
export const dateToDDMMYYYByDash = (date) => {
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

export const replaceDashToSlash = (str, search, replacement) => {
  return str.split(search).join(replacement);
};

export function formatDate(dobb) {
  var dateParts = dobb.split("/");
  return dateParts[1] + "/" + dateParts[0] + "/" + dateParts[2];
}
